import {defineStore} from "pinia";

export const useValidationWorkFlowActionStore = defineStore('validationWorkFlowAction', {
  state: () => ({
    action: {},
    actions: [],
    loading: false,
  }),
  actions: {
    setLoading(state, loading) {
      state.loading = loading
    },
    setAction(action) {
      this.action = action
    },
    setActions(actions) {
      this.actions = actions
    },
    addAction(action) {
      this.actions.unshift(action)
    },
    updateAction(action) {
      let index = this.actions.findIndex(cl => cl.id === action.id)
      this.actions.splice(index, 1, action)
    },
    deleteAction(action) {
      let index = this.actions.findIndex(cl => cl.id === action.id)
      this.actions.splice(index, 1)
    },
  },
});